<template>
	<div id="about">
		<NavMenu :activeIndex="curIndex"></NavMenu>
		<div class="liuBai"></div>
		<div class="bannerImgCon"><el-image class="bannerImg" :src="baseImgUrl + banner" fit="cover"></el-image></div>
		<div class="main">
			<div class="routerMenu">
				<router-link class="routerMenuItem" to="/intro"><p class="routerMenuItemTit">Profile</p></router-link>
				<router-link class="routerMenuItem" to="/org"><p class="routerMenuItemTit">Structure</p></router-link>
				<router-link class="routerMenuItem" to="/business"><p class="routerMenuItemTit">Business</p></router-link>
				<router-link class="routerMenuItem" to="/honor"><p class="routerMenuItemTit">Qualifications</p></router-link>
				<router-link class="routerMenuItem" to="/culture"><p class="routerMenuItemTit">Culture</p></router-link>
				<router-link class="routerMenuItem" to="/branch"><p class="routerMenuItemTit">Subsidiary</p></router-link>
			</div>
			<router-view></router-view>
		</div>
		<Bottom></Bottom>
	</div>
</template>

<script>
import NavMenu from '../../../copms/NavMenu'
import Bottom from '../../../copms/Bottom'
export default {
	name: "About",
	components: { NavMenu,Bottom },
	data() {
		return {
			curIndex: '2-1',
			baseImgUrl: process.env.VUE_APP_IMGURL,
			banner: ''
		}
	},
	mounted() {
		this.$api.get('about/getBanner').then(res => {
			this.banner = res;
		});
	}
}
</script>

<style>
	html{ width: 100%; height: 100%; }
	body { margin: 0; padding: 0; width: 100%; height: 100%; }
	::-webkit-scrollbar { width: 5px; height: 6px; }
	::-webkit-scrollbar-track { background-color: #ffffff; border-radius: 2px; }
	::-webkit-scrollbar-thumb { background-color: #73869c; border-radius: 2px; border: 1px solid #6d6d6d; }
	* { scrollbar-color: light; scrollbar-width: thin; } /*火狐*/
</style>

<style scoped>
	.routerMenu{ font-family: 'SiYuan-Light', sans-serif; }
	@media (max-width: 380px){
		.liuBai{ height: 88px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 96%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: fit-content; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: wrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 12px; height: fit-content; width: 32%; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; font-size: 12px; }
		}
	@media (min-width: 380px) and (max-width: 465px){
		.liuBai{ height: 88px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 96%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 12px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; font-size: 12px; margin: 15px 0 0 0; }
	}
	@media (min-width: 465px) and (max-width: 503px){
		.liuBai{ height: 88px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 96%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; font-size: 14px; margin: 15px 0 0 0; }
	}
	@media (min-width: 503px) and (max-width: 726px){
		.liuBai{ height: 88px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 96%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; letter-spacing: 1px; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; margin: 15px 0 0 3px; }
	}
	@media (min-width: 726px) and (max-width: 999px){
		.liuBai{ height: 98px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 92%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; letter-spacing: 1px; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; line-height: 50px; margin: 0; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
		.liuBai{ height: 98px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 80%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; letter-spacing: 1px; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; line-height: 50px; margin: 0; }
	}
	@media (min-width: 1252px) and (max-width: 1759px){
		.liuBai{ height: 98px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 80%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; letter-spacing: 1px; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; line-height: 50px; margin: 0; }
	}
	@media (min-width: 1760px) and (max-width: 2200px){
		.liuBai{ height: 98px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 80%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; letter-spacing: 1px; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; line-height: 50px; margin: 0; }
	}
	@media (min-width: 2201px){
		.liuBai{ height: 98px; }
		.router-link-active{ color: #58789e !important; border-bottom: 2px solid #58789e; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ width: 80%; margin: 0 auto; min-height: 400px; }
		.routerMenu{ height: 50px; border-bottom: 2px solid #dde8f1; display: flex; flex-wrap: nowrap; animation: fadeInDown; animation-duration: 1s; }
		.routerMenuItem{ text-decoration: none; color: #c2c2c2; font-size: 15px; height: 100%; width: 116px; display: block; text-align: center; }
		.routerMenuItem:hover{ color: #58789e; letter-spacing: 1px; }
		.routerMenuItemTit{ transition: all 0.3s linear; display: block; height: 50px; line-height: 50px; margin: 0; }
	}
</style>